import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { AddIcon, RemoveIcon } from '../../components/Icons';
import { Button, Col, Row } from 'react-bootstrap';

const InlineItemForm = (props) => {
  const [inputList, setInputList] = useState([{ itemName: "", price: "" }]);
  const [errors, setErrors] = useState([{ itemName: "", price: "" }]);

  const handleRemoveClick = index => {
    const list = [...inputList];
    const errorsCopy = [...errors];

    list.splice(index, 1);
    errorsCopy.splice(index, 1);

    setInputList(list);
    setErrors(errorsCopy);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { itemName: "", price: "" }]);
    setErrors([...errors, { itemName: "", price: "" }]);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    const errorsCopy = [...errors];

    list[index][name] = value;
    errorsCopy[index][name] = validateInput(name, value);

    setInputList(list);
    setErrors(errorsCopy);
  };

  const handlePriceKeyPress = (e) => {
    const isValidInput = /^[0-9\b]*(\.\d{0,4})?$/.test(e.target.value + e.key);
    if (!isValidInput) {
      e.preventDefault();
    }
  };

  const validateInput = (name, value) => {
    // Implement your validation logic here
    if (name === 'itemName' && value.trim() === "") {
      return "Item Name is required";
    } else if (name === 'price' && (value.trim() === "" || isNaN(parseFloat(value)))) {
      return "Price must be a valid number";
    }

    return "";
  };

  const handleSubmit = () => {
    // Filter out items without both itemName and price
    const validItems = inputList.filter(item => item.itemName && item.price !== "");

    // Check for errors before calculating total
    // const hasErrors = errors.some(error => error.itemName || error.price);
    // if (hasErrors) {
    //   alert("Please fix the errors in the form");
    //   return;
    // }

    // Calculate the total price
    const totalPrice = validItems.reduce((total, item) => total + parseFloat(item.price), 0);
    const validData = validItems.map(item => ({ [item.itemName]: item.price }));
    props.setInlineItem(validData);
    props.setInlineTotal(totalPrice)
    // You can use the total price as needed, e.g., send it to an API, update state, etc.
  };

  useEffect(()=>{
    const validItems = inputList.filter(item => item.itemName && item.price !== "");
    const validData = validItems.map(item => ({ [item.itemName]: item.price }));
    if(validData?.length < 1){
        props.setInlineTotal(0);
    }
  },[inputList])
  return (
    <div className='w-100'>
      {inputList.map((x, i) => {
        return (
          <div key={i} className='add-item-row'>
            <div className='item-field'>
              <Row className='g-3'>
                <Col xs={6}>
                  <Form.Label>Item Name</Form.Label>
                  <Form.Control
                    type="text"
                    name='itemName'
                    placeholder="Item name here"
                    value={x.itemName}
                    onChange={(e) => handleInputChange(e, i)}
                  />
                  <p className="text-danger text-small">{errors[i].itemName}</p>
                </Col>
                <Col xs={6}>
                  <Form.Label>Item Price</Form.Label>
                  <Form.Control
                    type="text"
                    name="price"
                    value={x.price}
                    placeholder="Price here"
                    onChange={(e) => handleInputChange(e, i)}
                    onKeyPress={handlePriceKeyPress}
                  />
                  <p className="text-danger text-small">{errors[i].price}</p>
                </Col>
              </Row>
            </div>
            {inputList.length !== 1 &&
              <div className='action-btn' onClick={() => handleRemoveClick(i)}>
                <RemoveIcon />
              </div>}
            {inputList.length - 1 === i && <div className='action-btn' onClick={handleAddClick}> <AddIcon /></div>}
          </div>
        )
      })}
      <Button variant='primary' className='mt-2' onClick={() => handleSubmit()}>Submit</Button>
    </div>
  );
}

export default InlineItemForm;
